import { render, staticRenderFns } from "./imageShadow.vue?vue&type=template&id=010e8184&"
import script from "./imageShadow.vue?vue&type=script&lang=ts&"
export * from "./imageShadow.vue?vue&type=script&lang=ts&"
import style0 from "./imageShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports